import { useAuth } from '@clerk/clerk-react';
import { DiscoveryApp } from '@/discovery';
import '@/discovery/styles.css';
import { env } from '@/lib/env';

/**
 * Thin mount point for the discovery UI (src/discovery). It only wires Clerk
 * auth and the backend URL. Mounted at `discovery/*`: Discovery routes its own
 * screens below /admin/discovery.
 */
export function AdminDiscovery(): JSX.Element {
  const { getToken, userId } = useAuth();

  if (!env.discoveryApiUrl) {
    return (
      <div className="flex h-full items-center justify-center p-8 text-sm text-muted-foreground">
        Discovery is not configured. Set <code>VITE_DISCOVERY_API_URL</code> in your environment to enable it.
      </div>
    );
  }

  return (
    <div className="h-[calc(100vh-3.5rem)]">
      <DiscoveryApp
        apiUrl={env.discoveryApiUrl}
        getToken={() => getToken()}
        role="admin"
        features={{ outreach: false }}
        basePath="/admin/discovery"
        currentUserId={userId ?? null}
      />
    </div>
  );
}
